
<div class="badge-positioning">
  <div #element (mouseenter)="mouseEnter()" class="circle">
    <span class="icon icon-info-filled "></span>
  </div>
  <div class="tooltip-wrapper">
    <div class="tooltip-content" [ngClass]="{ up: openUpwards() }">
      <ng-content></ng-content>
    </div>
  </div>
</div>
